export enum ActualArrivalSelectorMode {
  summary,
  edit,
}

export enum ActualArrivalSelectorField {
  datetime = 'datetime',
  comments = 'comments',
}
